(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/list", [], factory);
	else if(typeof exports === 'object')
		exports["list"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["list"] = factory();
})(this, function() {
return 